<template>
    <img class="logo" alt="Sckan NLI logo" src="./assets/sckan-nli-beta-logo.svg">
    <h3>Authentication Error</h3>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6 mx-auto my-auto">
                <div class="alert alert-danger" v-if="hasError" role="alert">
                    Oops, something went terribly wrong<br> and we couldn\'t fetch your ORCID iD
                </div>
                <div class="alert alert-danger" v-if="beenDenied">
                    Oops, you have denied access by ORCID
                </div>
            </div>
        </div>
    </div>
    <OrcidWidget :clientId="clientID" env="production"  redirectUri="https://fdi-nlp.ucsd.edu/callback" />
</template>
<script>
import OrcidWidget from './components/OrcidWidget.vue';
export default {
    props: ["error"],
    name: 'AuthErrView',
    components: {
        OrcidWidget
    },
    data() {
        return {
            clientID: process.env.VUE_APP_CLIENT_ID,
        }
    },
    computed: {
        beenDenied() {
            console.log('error:' + this.error)
            return this.error && 'access denied' === this.error
        },
        hasError() {
            return this.error && 'access denied' !== this.error
        }
    },

}
</script>
<style>
.logo {
    width: auto;
    height: 200px;
}
</style>
